/**
 * Page View Factory
 * Evento page_view automático para SPA (React Router).
 */

import { gtagEvent } from '../utils/gtag';

export function trackPageView(pagePath: string, pageTitle?: string): void {
  const params = {
    page_location: typeof window !== 'undefined' ? window.location.href : pagePath,
    page_title: pageTitle || document?.title || pagePath,
    page_path: pagePath,
  };

  gtagEvent('page_view', params);
}
